import { getStorage } from '@/utils/helper'

const product = `${window.location.protocol}//api.kaoyanbox.com`
const pre = `${window.location.protocol}//pre-api.kaoyanbox.net`
const daily = `${window.location.protocol}//test-api.kaoyanbox.net`
let host = daily
// 环境判断
if (location) {
  if (location.host.includes('admin.kaoyanbox.com')) {
    host = product
  } else if (location.host.includes('admin.kaoyanbox.net')) {
    host = pre
    if (location.host.includes('test')) {
      host = daily
    }
  }
  // 本地开发环境
  // if (process.env.NODE_ENV === 'development') {
  //   host = 'http://127.0.0.1:7001'
  // }
}

export function imgUploadUrl() {
  return `${host}/api/v1/back/upload/image`
}

export function fileUploadUrl() {
  return `${host}/api/v1/back/upload/file`
}

export function fileUploadPrivateUrl() {
  return `${host}/api/v1/back/upload/private/file`
}

export function uploadHeaders() {
  return {
    Authorization: getStorage('admin_token') || ''
  }
}
// 上传文件请求头
export function uploadFileHeaders() {
  return {
    'Authorization': getStorage('admin_token') || ''

  }
}

